import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
export default {
    findAll: (keywords, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "searchOptions": {
                    "pageIndex": page,
                    "pageSize": pageSize,
                    "keywords": keywords
                }
            }
            HTTP.post(config.apiEndpoints.transactionTypeUri.concat('find'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.transactionTypeUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.transactionTypeUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.transactionTypeUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    remove: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.delete(config.apiEndpoints.transactionTypeUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.transactionTypeUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}